import type { ApolloError } from '@apollo/client/core'

export const isApolloError = (error: any | ApolloError): error is ApolloError =>
  !!(error as ApolloError)?.graphQLErrors?.length
